


































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {MdbsIdProvider} from "@/api/tsclient";
import {deepCopy, isDate} from "@/auxillary";
import {instituteWithStudySystemModule, realPatientModule, studySystemModule} from "@/store";
import {formatDate} from "@/auxillary/date";
import InstituteDto = MdbsIdProvider.InstituteDto;
import StudySystemDto = MdbsIdProvider.StudySystemDto;
import PatientConsentDto = MdbsIdProvider.PatientConsentDto;
import RealPatientDto = MdbsIdProvider.RealPatientDto;

@Component({
  filters: {
    formatDate(date: Date): string {
      return formatDate(date);
    }
  }
})
export default class PatientConsentEditDialog extends Vue {
  @Prop({required: true})
  patientConsent!: PatientConsentDto;

  dialogDate: boolean = false;
  valid: boolean = false;

  grantDate: string | undefined;
  realPatients: RealPatientDto[] = [];
  institutes: InstituteDto[] = [];
  studySystems: StudySystemDto[] = [];

  rules: any = {
    required: (value: any) => !!value || 'Wird benötigt',
    isDate: (v: string) => isDate(v) || 'Kein gültiges Datum',
  }

  async mounted() {
    await realPatientModule.loadAll();
    this.realPatients = realPatientModule.patients;

    await studySystemModule.loadAll();
    this.studySystems = studySystemModule.studySystems;

    await instituteWithStudySystemModule.loadAll();
    this.institutes = instituteWithStudySystemModule.institutesWithStudySystem;
  }

  @Watch('patientConsent', {
    immediate: true,
    deep: true
  })
  onPatientConsentChanged(patientConsent: PatientConsentDto | null) {
    if (patientConsent != null && this.patientConsent.realPatientId != null) {
      this.grantDate = formatDate(patientConsent.grantDate, "-");
    } else {
      this.grantDate = undefined;
    }
  }

  getPatienConsentForSave() {
    let patientConsent = deepCopy(this.patientConsent);
    patientConsent.grantDate = new Date(this.grantDate ?? "");
    patientConsent.realPatientId = this.patientConsent.realPatient?.id ?? "";
    patientConsent.studySystemId = this.patientConsent.studySystem?.id ?? "";
    patientConsent.instituteId = this.patientConsent.institute?.id ?? "";
    console.log("patient for save " + JSON.stringify(patientConsent))

    return patientConsent;
  }
}
